var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'field-invalid': _vm.invalid, 'field-valid': _vm.valid, 'field-required': _vm.required}},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"field-note"},[_vm._t("note")],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"field-txt-invalid"},[_vm._v(_vm._s(_vm.message))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acd2f2b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/views/components/validField.vue
// module id = 803
// module chunks = 0